import { createRouter, createWebHistory } from 'vue-router'

// Sayfaları içe aktar
import Login from '../views/Login.vue'
import SelectLesson from '../views/SelectLesson.vue'
import SelectTeacher from '../views/SelectTeacher.vue'
import SelectTime from '../views/SelectTime.vue'
import AdminPanel from '../views/AdminPanel.vue'
import StudentPanel from '../views/StudentPanel.vue'
import TeacherPanel from '../views/TeacherPanel.vue'
import PanelRedirect from '../components/PanelRedirect.vue'
import StudentStatistics from '../views/StudentStatistics.vue'
import AdminStatistics from '../views/AdminStatistics.vue'

// Kurumsal site sayfaları
import CorporateHome from '../views/CorporateHome.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import Blog from '../views/Blog.vue'
import BlogDetail from '../views/BlogDetail.vue'

const routes = [
  {
    path: '/',
    name: 'CorporateHome',
    component: CorporateHome,
    meta: {
      title: 'Modern Kurs – Kozan\'ın En İyi Dershanesi | TYT AYT Hazırlık Kursu',
      description: 'Modern Kurs, Kozan\'da üniversiteye hazırlık ve okul derslerine destek konusunda öğrencilerin güvenle tercih ettiği modern bir dershanedir. TYT AYT hazırlık kursları, bireysel takip, deneme sınavları.',
      keywords: 'modern kurs kozan, kozan dershanesi, kozan tyt ayt hazırlık, kozan üniversite hazırlık, kozan öğretmen, kozan ders'
    }
  },
  {
    path: '/home',
    redirect: '/'
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: 'Hakkımızda - Modern Kurs',
      description: 'Modern Kurs hakkında bilgi edinin. Online randevu sistemi ile eğitimde yeni dönem.',
      keywords: 'hakkımızda, modern kurs, online eğitim, randevu sistemi'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: 'İletişim - Modern Kurs Kozan | Kozan Eğitim Merkezi',
      description: 'Modern Kurs Kozan ile iletişime geçin. Adres: Kozan/Adana, Telefon: 0552 683 34 03 - 0552 683 34 09, E-posta: modernkurs01@gmail.com.',
      keywords: 'modern kurs kozan iletişim, kozan eğitim merkezi telefon, kozan kurs adresi, modern kurs adana'
    }
  },
  {
    path: '/blogs',
    name: 'Blog',
    component: Blog,
    meta: {
      title: 'Blog - Modern Kurs',
      description: 'Modern Kurs blog sayfası. Eğitim ve teknoloji hakkında güncel yazılar.',
      keywords: 'blog, eğitim, teknoloji, modern kurs'
    }
  },
  {
    path: '/blog/:id',
    name: 'BlogDetail',
    component: BlogDetail,
    meta: {
      title: 'Blog Yazısı - Modern Kurs',
      description: 'Modern Kurs blog yazısı detay sayfası.',
      keywords: 'blog, eğitim, teknoloji'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/panel',
    name: 'PanelRedirect',
    component: PanelRedirect
  },
  {
    path: '/panel/ogrenci',
    name: 'StudentPanel',
    component: StudentPanel,
    children: [
      {
        path: 'select-lesson',
        name: 'StudentSelectLesson',
        component: SelectLesson
      },
      {
        path: 'select-teacher/:lessonId',
        name: 'StudentSelectTeacher',
        component: SelectTeacher
      },
      {
        path: 'select-time/:teacherId',
        name: 'StudentSelectTime',
        component: SelectTime
      },
      {
        path: 'statistics',
        name: 'StudentStatistics',
        component: StudentStatistics
      }
    ]
  },
  {
    path: '/panel/hoca',
    name: 'TeacherPanel',
    component: TeacherPanel
  },
  {
    path: '/panel/admin',
    name: 'AdminPanel',
    component: AdminPanel
  },
  {
    path: '/panel/admin/statistics',
    name: 'AdminStatistics',
    component: AdminStatistics
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Eğer kaydedilmiş pozisyon varsa (geri/ileri butonları) onu kullan
    if (savedPosition) {
      return savedPosition
    }
    // Yeni sayfaya gidildiğinde en üste git
    return { top: 0 }
  }
})

// Panel route'ları için role guard — sayfa mount olmadan yetkisiz erişimi keser.
// Client-side kontrol; asıl koruma backend AdminMiddleware/AuthMiddleware. Bu guard
// sadece UX için: yanlış rol → admin arayüzü hiç render olmasın.
const roleGuards = [
  { prefix: '/panel/admin', roles: ['admin'] },
  { prefix: '/panel/hoca', roles: ['teacher', 'hoca'] },
  { prefix: '/panel/ogrenci', roles: ['student', 'ogrenci'] }
]

router.beforeEach((to, from, next) => {
  // Sayfa başlığını güncelle
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // Meta description güncelle
  if (to.meta.description) {
    let metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', to.meta.description)
    }
  }

  // Meta keywords güncelle
  if (to.meta.keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]')
    if (metaKeywords) {
      metaKeywords.setAttribute('content', to.meta.keywords)
    }
  }

  // Role guard (panel altı route'lar)
  const guard = roleGuards.find(g => to.path.startsWith(g.prefix))
  if (guard) {
    const token = localStorage.getItem('token')
    const userStr = localStorage.getItem('user')
    if (!token || !userStr) {
      return next('/login')
    }
    try {
      const user = JSON.parse(userStr)
      if (!user || !guard.roles.includes(user.role)) {
        return next('/login')
      }
    } catch (e) {
      return next('/login')
    }
  }

  next()
})

export default router 